/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Image } from "../../../../../../AbstractElements";
import {
  fetchChatMemberAsync,
  setChats,
  setLoading,
  setSelectedUser,
} from "../../../../../../ReduxToolkit/Reducers/ChatReducer";
import { RootState } from "../../../../../../ReduxToolkit/Store";
import {
  AllMembersType,
  ChatType,
  MessagesType,
} from "../../../../../../Types/Chat.type";
import { dynamicImage } from "../../../../../../Utils";
import {
  getAPIURL,
  getAPIURLAWS,
  getUserID,
} from "../../../../../../services/helper";
import http from "../../../../../../services/http";
import data from "../../../../../../services/config";
import { toast } from "react-toastify";

const currentUserId = Number(getUserID());
const api_url = getAPIURLAWS();
const api_url_site = getAPIURL();

export default function ChatMessages() {
  const bottomRef = useRef<HTMLDivElement | null>(null);
  const chatContainerRef = useRef<HTMLDivElement | null>(null); // Ref for msger-chat container
  const {
    isGroup,
    allMembers,
    chats,
    selectedUser,
    currentUser,
    selectedGroup,
  } = useSelector((state: RootState) => state.chat);
  const dispatch = useDispatch();

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  };

  const fetchChatAsync = () => {
    if (chats.length > 0) {
      if (isGroup && selectedGroup) {
        const chat = chats.find(
          (x: ChatType) => x.id === `GROUP-${selectedGroup.groupId}`
        );
        if (chat && !chats.some((c) => c.id === chat.id)) {
          dispatch(setChats([...chats, chat]));
          dispatch(setSelectedUser(chat.users));
        }
      } else {
        const chat = chats.filter((x: ChatType) =>
          x.users.includes(currentUserId)
        );
        if (chat.length > 0) {
          const selectedUserId = chat[0].users.find(
            (x: number) => x !== currentUserId
          );
          const oneSelect = allMembers.find(
            (x: AllMembersType) => x.id === selectedUserId
          );
          if (oneSelect) {
            dispatch(setChats(chat));
            dispatch(setSelectedUser(oneSelect));
          }
        }
      }
    }
  };

  useEffect(() => {
    dispatch(fetchChatMemberAsync());
    fetchChatAsync();
  }, [dispatch, chats.length, allMembers.length, selectedGroup]);

  const selectedChat =
    isGroup && selectedGroup
      ? chats.find((x: ChatType) => x.id === `GROUP-${selectedGroup.groupId}`)
      : allMembers && chats && selectedUser
      ? chats.find(
          (x: ChatType) =>
            x.users.includes(currentUser.id as number) &&
            x.users.includes(selectedUser.id)
        )
      : null;

  useEffect(() => {
    if (selectedChat && selectedChat.messages.length > 0) {
      scrollToBottom();
    }
  }, [selectedChat]);

  return (
    <>
      {allMembers && chats && (selectedUser || isGroup) ? (
        <div className="msger-chat" ref={chatContainerRef}>
          {selectedChat && selectedChat.messages.length > 0 ? (
            selectedChat.messages.map((item: MessagesType, index: number) => {
              const participator = allMembers.find(
                (x: AllMembersType) => x.id === item.sender
              );
              return (
                <div
                  className={`msg left-msg ${
                    item.sender === currentUser.id ? "pull-right" : ""
                  }`}
                  key={index}
                >
                  <div className="msg-img">
                    <Image
                      src={
                        participator?.image
                          ? participator.image
                          : dynamicImage("avtar/3.jpg")
                      }
                      className={`rounded-circle ${
                        item.sender !== currentUser.id
                          ? "float-start"
                          : "float-end"
                      } chat-user-img img-30 h-auto`}
                      alt=""
                    />
                  </div>
                  <div className="msg-bubble">
                    <div className="msg-info">
                      <div className="msg-info-name">{participator?.name}</div>
                      <div className="msg-info-time">{item.time}</div>
                    </div>
                    <div className="msg-text">{item.text}</div>
                  </div>
                </div>
              );
            })
          ) : (
            <></>
          )}
          <div ref={bottomRef}></div>
        </div>
      ) : (
        <div className="loading"></div>
      )}
    </>
  );
}
